import {AnyAction, Dispatch} from "@reduxjs/toolkit";
import axios from "axios";
import {previewStatusUrl, promoCodeUrl} from "./url";
import {setPreviewDataFromBackend, setPromoCodeDiscount, setPromoCodeFromBackend} from "../store/makerDataSlice";
import * as Sentry from "@sentry/react";

export let canGetPreviewStatus = {
    value: true
};

export default async function promoCodeApply(argsData: any) {

    let promoCode = argsData.promoCode;
    let themeId = argsData.themeId;
    let slidesNum = argsData.slidesNum;
    let dispatch = argsData.dispatch;
    let makerData = argsData.makerData;

    let vkLaunchParams = {};
    if (makerData?.vkLaunchParams?.vk_app_id) {
        for (const [key, value] of Object.entries(makerData.vkLaunchParams)) {
            // @ts-ignore
            vkLaunchParams[key] = value;
        }
    }

    const params = {
        promoCode: promoCode,
        themeId: themeId,
        slidesNum: slidesNum,
        ...vkLaunchParams
    };
    try {
        if (promoCode?.length === 0) {
            dispatch(setPromoCodeDiscount(0));
            return;
        }
        const response = await axios.get(promoCodeUrl, {params: params});
        if (typeof response.data.result !== 'undefined') {
            dispatch(setPromoCodeFromBackend(response.data));
        } else {
            Sentry.captureException(
                new Error('Failed to apply promoCode.'),
                {
                    extra: {
                        url: promoCodeUrl,
                        params: params,
                        responseData: JSON.stringify(response.data),
                        responseConfig: JSON.stringify(response.config)
                    }
                }
            )
        }
    } catch (err) {
        Sentry.captureException(
            new Error('Failed to apply promoCode. Error.'),
            {
                extra: {
                    url: promoCodeUrl,
                    params: params,
                    error: err,
                    responseConfig: axios.isAxiosError(err) ? JSON.stringify(err.response?.config) : '',
                    responseData: axios.isAxiosError(err) ? JSON.stringify(err.response?.data) : ''
                }
            }
        )
    }
}